import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.762 5.762A6.7 6.7 0 0 1 10.5 3.8c3.791 0 6.7 2.712 6.7 5.865 0 .638-.285 1.274-.83 1.758-.548.487-1.31.774-2.12.774h-2.078a2.467 2.467 0 0 0-1.343 4.555.283.283 0 0 1-.256.447l-.073-.004a6.7 6.7 0 0 1-6.7-6.697c0-1.777.706-3.48 1.962-4.736M10.5 2.2a8.3 8.3 0 0 0-8.3 8.298 8.297 8.297 0 0 0 8.268 8.297 1.883 1.883 0 0 0 1.408-3.262.8.8 0 0 0-.156-.112.867.867 0 0 1 .434-1.624h2.096c1.178 0 2.325-.416 3.183-1.178.862-.766 1.367-1.827 1.367-2.954 0-4.209-3.808-7.465-8.3-7.465m.417 2.916a1.633 1.633 0 1 0 0 3.267 1.633 1.633 0 0 0 0-3.267m-3.334 2.5a1.633 1.633 0 1 0 0 3.266 1.633 1.633 0 0 0 0-3.267m6.667 0a1.633 1.633 0 1 0 0 3.266 1.633 1.633 0 0 0 0-3.267",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }